module.exports = __webpack_public_path__ + "img/course_003.66c8d27.webp";